<h1 mat-dialog-title class="d-flex align-items-center justify-content-between">
    <span>Artifactory Category Change</span>
    <i class="fa fa-times model_close cursor-pointer" (click)="closeDialog(false)"></i>
</h1>

<div mat-dialog-content class="popup-content">
    <label class="fw-600">Name: <span *ngIf="data.values.length == 1">{{data.values[0].fileName}}</span> </label>
    <!-- <label>Artifactory Category</label> -->
    <div>
        <span class="labelName">Artifactory Category <sup class="requiredStar">*</sup></span>
    </div>
    <mat-form-field class="custom_select mb-2">
        <mat-select #categorySelection placeholder="Select Category"
            [ngModel]="templateId" (selectionChange)="templateChange($event)">
            <mat-option *ngFor="let template of templates" [value]="template.id">{{template.category}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <!-- <select class="form-control mb-2" #categorySelection [ngModel]="templateId" (change)="templateChange($event)">
        <option *ngFor="let template of templates" [value]="template.id">{{template.category}}</option>
    </select> -->
    <!-- <label class="mt-2">Artifactory Category Type</label> -->
    <div>
        <span class="labelName">Artifactory Category Type<sup class="requiredStar">*</sup></span>
    </div>
    <mat-form-field class="custom_select mb-2">
        <mat-select #subCategorySelection placeholder="Select Category Type" [disabled]="!templateId"
            [ngModel]="subTemplateId" (selectionChange)="subTemplateChange($event)">
            <mat-option *ngFor="let template of subTemplates" [value]="template.id">{{template.subCategory}}
            </mat-option>
        </mat-select>
    </mat-form-field>

    <!-- <select class="form-control mb-2" #subCategorySelection [disabled]="!templateId" [ngModel]="subTemplateId"
        (change)="subTemplateChange($event)">
        <option [value]="0">---Select Category Type---</option>
        <option *ngFor="let template of subTemplates" [value]="template.id">{{template.subCategory}}</option>
    </select> -->
</div>
<div mat-dialog-actions class="popup-buttons d-flex justify-content-end">
    <button (click)="moveToFolder()" class="custom_btn primary_btn_base">Update</button>
    <button (click)="closeDialog(false)" class="custom_btn inverted_btn_base ml-2">Cancel</button>
</div>